document.addEventListener("DOMContentLoaded", () => {
  // Toggle description height on "Read more"/"Read less" button click
  setTimeout(() => {
    const description__read_more_button = document.querySelector(
      ".template-steering-wheel-products-new .description__read-more-button"
    );
    const description__details = document.querySelector(
      ".template-steering-wheel-products-new .description__details"
    );
    const description__text = document.querySelector(
      ".template-steering-wheel-products-new .description__text"
    );
    const description_height = description__text.dataset.descriptionHeight;

    if (
      description__read_more_button &&
      description__details &&
      description__text
    ) {
      description__read_more_button.addEventListener("click", (e) => {
        if (description__read_more_button.innerText === "Read More") {
          description__text.style.height = "auto";
          description__read_more_button.innerText = "Read Less";
        } else {
          description__read_more_button.innerText = "Read More";
          description__text.style.height = `${description_height}px`;
        }

        // Add scroll padding so the details are not hidden behind sticky headers
        const scrollPadding = 150; // Adjust this value as needed (in px)
        const rect = description__details.getBoundingClientRect();
        const absoluteElementTop = window.pageYOffset + rect.top;
        const offsetPosition = absoluteElementTop - scrollPadding;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      });

      // Listen for the <details> open/close toggle to control the height
      description__details.addEventListener("toggle", () => {
        if (description__details.hasAttribute("open")) {
          description__text.style.height = `${description_height}px`;
        } else {
          description__text.style.height = `${description_height}px`;
        }
      });
    }
  }, 1000);
});
